import { invalidateCache } from 'api/urql/helpers/mutation';

export const updateReadStatusOnAllJobAlerts = (results, args, cache, info) => {
  // handlers go here
  invalidateCache('jobRequest')(results, args, cache, info);
};
